<template>
  <div class="cards-wrapper">
    <ul v-if="paymentMethods.length" class="member-cards__list">
      <li v-for="pm in paymentMethods" :key="pm.id" class="member-cards__card member-card">
        <div class="member-card__data">
          <PaymentDetailsCardBrand :brand="pm.card.brand" />
          <span v-if="pm.card.last4" class="member-card__text text-value">ending with {{ pm.card.last4 }}</span>
        </div>

        <div class="member-card__controls">
          <span v-if="pm.isDefault" class="member-card__default-mark">Default</span>
          <button
            v-else
            class="member-card__set-default-btn"
            :class="{ 'btn-active-state': pm.id === processingId }"
            :disabled="loading"
            type="button"
            @click="$emit('changing-default', pm.id)"
          >
            Set as default
          </button>

          <button
            v-if="!pm.isDefault || paymentMethods.length === 1"
            class="member-card__delete-btn"
            :class="{ 'btn-active-state': pm.id === processingId }"
            :disabled="loading"
            type="button"
            @click="$emit('deleting', pm)"
          >
            <AppTrashIcon class="member-card__delete-btn-icon" />
          </button>
        </div>
      </li>
    </ul>

    <p v-else-if="!loading" class="member-cards__list-empty-msg">No card has been added yet.</p>
    <div v-if="loading" class="loader-wrapper">
      <AppLoader :border-width="4" :margin="0" :size="32" />
    </div>
  </div>
</template>

<script>
import PaymentDetailsCardBrand from '@/components/partials/profile/PaymentDetailsCardBrand';
import AppTrashIcon from '@/components/icons/AppTrashIcon.vue';

export default {
  name: 'PaymentMethods',
  components: { AppTrashIcon, PaymentDetailsCardBrand },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    paymentMethods: {
      type: Array,
      required: true,
    },
    processingId: {
      type: String,
      default: null,
    },
  },
};
</script>
